import angular from 'angular';
import { ULoadingHelper } from '@updater/angular-common';
import { ShareMovePublicConfig } from './public.config';
import { ShareMovePublicComponent } from './public.component';
import { GoogleMapModule } from '../../../common/directives';

export const ShareMovePublicModule = angular
  .module('app.steps.share-move.public', [
    GoogleMapModule.name,
    ULoadingHelper.name,
  ])
  .config(ShareMovePublicConfig)
  .component('updShareMovePublic', ShareMovePublicComponent);
